import { Injectable } from '@angular/core';
import {
  AppConfigService as AppConfig,
  Configuration
} from '../services/init/app-config.service';
import { BaseApi } from './base-api';
import { ConfigApiConstant } from '../constants/parmed-api.constant';

@Injectable()
export class ConfigApi extends BaseApi {
  /******************Properties******************/
  readonly SEARCH_PRODUCTS_URL: string = ConfigApiConstant.SEARCH_PRODUCTS;
  readonly BARCODE_SEARCH_URL: string = ConfigApiConstant.BARCODE_SEARCH;
  readonly GET_PRODUCTS_INV_PRICE_URL: string =
    ConfigApiConstant.GET_PRODUCTS_INV_PRICE;
  readonly VALIDATE_PRODUCTS_URL: string = ConfigApiConstant.VALIDATE_PRODUCT;
  readonly GET_PRODUCT_TYPEFORWARD_URL: string = ConfigApiConstant.GET_PRODUCT_TYPEFORWARD;
  readonly GET_STATIC_DATA_URL: string = ConfigApiConstant.GET_STATIC_DATA;
  readonly GET_GLOBAL_CHAT_SETTINGS_URL: string =
    ConfigApiConstant.GET_GLOBAL_CHAT_SETTINGS;
  readonly AUTHENTICATE_URL: string = ConfigApiConstant.AUTHENTICATE;
  readonly CONTACT_US_URL: string = ConfigApiConstant.CONTACT_US;
  readonly GET_CREDIT_CARDS_URL: string = ConfigApiConstant.GET_CREDIT_CARDS;
  readonly ADD_CREDIT_CARD_URL: string = ConfigApiConstant.ADD_CREDIT_CARD;
  readonly UPDATE_CREDIT_CARD_URL: string =
    ConfigApiConstant.UPDATE_CREDIT_CARD;
  readonly DELETE_CREDIT_CARD_URL: string =
    ConfigApiConstant.DELETE_CREDIT_CARD;
  readonly GET_SIGNED_DATA_URL: string = ConfigApiConstant.GET_SIGNED_DATA;
  readonly GET_ACCESS_TOKEN_URL: string = ConfigApiConstant.GET_ACCESS_TOKEN;
  readonly GET_PAYPAL_TOKEN_DETAILS_URL: string = ConfigApiConstant.GET_PAYPAL_TOKEN_DETAILS;
  readonly GET_RESPONSE_PACKET_URL: string =
    ConfigApiConstant.GET_RESPONSE_PACKET;
  readonly GET_PRODUCT_IMAGES_URL: string =
    ConfigApiConstant.GET_PRODUCT_IMAGES;
  readonly GET_PRODUCT_DETAILS_URL: string =
    ConfigApiConstant.GET_PRODUCT_DETAILS;
  readonly GET_PRODUCT_PURCHASE_HISTORY_URL: string =
    ConfigApiConstant.GET_PRODUCT_PURCHASE_HISTORY;
  readonly GET_PRODUCT_SUBSTITUTES_URL: string =
    ConfigApiConstant.GET_PRODUCT_SUBSTITUTES;
  readonly GET_PRODUCT_HISTORY_URL: string =
    ConfigApiConstant.GET_PRODUCT_HISTORY;
  readonly GET_SERVER_DATETIME_URL: string =
    ConfigApiConstant.GET_SERVER_DATETIME;
  readonly GET_PRODUCT_CATALOG_URL: string =
    ConfigApiConstant.GET_PRODUCT_CATALOG;
  readonly GET_PRODUCTS_BY_CATALOG_ID_URL: string =
    ConfigApiConstant.GET_PRODUCTS_BY_CATALOG_ID;
  readonly GET_FAVORITES_URL: string =
    ConfigApiConstant.GET_FAVORITES;
  readonly GET_FAVORITE_PRODUCTS_URL: string =
    ConfigApiConstant.GET_FAVORITE_PRODUCTS;
  readonly CREATE_FAVORITE_LIST_URL: string =
    ConfigApiConstant.CREATE_FAVORITE_LIST;
  readonly ADD_PRODUCT_TO_FAVORITE_LIST_URL: string =
    ConfigApiConstant.ADD_PRODUCT_TO_FAVORITE_LIST;
  readonly DELETE_FAVORITE_LIST_URL: string =
    ConfigApiConstant.DELETE_FAVORITE_LIST;
  readonly DELETE_PRODUCT_FROM_FAVORITE_LIST_URL: string =
    ConfigApiConstant.DELETE_PRODUCT_FROM_FAVORITE_LIST;
  readonly RENAME_FAVORITE_LIST_URL: string =
    ConfigApiConstant.RENAME_FAVORITE_LIST;
  readonly MOVE_FAVORITE_PRODUCT_URL: string =
    ConfigApiConstant.MOVE_FAVORITE_PRODUCT;
    readonly ADD_PRODUCT_TO_WATCH_LIST_URL: string =
    ConfigApiConstant.ADD_PRODUCT_TO_WATCH_LIST;
    readonly DELETE_PRODUCT_FROM_WATCH_LIST_URL: string =
    ConfigApiConstant.DELETE_PRODUCT_FROM_WATCH_LIST;
    readonly GET_WATCHLIST_PRODUCTS_URL: string =
    ConfigApiConstant.GET_WATCHLIST_PRODUCTS;
    readonly VALIDATE_NDC_URL: string =
    ConfigApiConstant.VALIDATE_NDC;
  readonly GET_SERVER_METAINFO_URL: string =
    ConfigApiConstant.GET_SERVER_METAINFO;
    readonly GET_PROMOTION_URL: string =
    ConfigApiConstant.GET_PROMOTION;
    readonly GET_CATEGORY_ITEM_URL: string =
    ConfigApiConstant.GET_CATEGORY_ITEM;
    readonly GET_ITEMS_ON_SALE_FROM_PRODUCT_HISTORY_URL: string = 
    ConfigApiConstant.GET_ITEMS_ON_SALE_FROM_PRODUCT_HISTORY;
    
  /******************Properties******************/

  /***************Constructor***************/
  constructor(config: AppConfig) {
    super(config, Configuration.CONFIG_API_ENDPOINT);
    this.reset(this);
  }
  /***************Constructor***************/
}
